import {
  SHOP_PLACEHOLDER,
  FM_SHOP_DETIALS,
  FM_SHOP_HEADER,
  FM_SHOP_ID,
  QUERY_SHOPSUBCATEGORIES_TITLE,
  QUERY_DISTANCES_TITLE,
  QUERY_REGIONS_TITLE,
  SHOP_CATEGORY_ID,
  ERROR_TIPS,
  HEAD_GO_BACK_ITEM,
  MC_SHOPS,
  SHOP_SUB_CATEGORIES_ID,
  E_BEFORE_LOGIN_URL_EXHIBITION_NEW,
  APP_ALERT_SHOW,
  CURRENTPAGE,
  LANDINGPAGE,
  ALERT_SHOW_CLOSE,
  LOCATION_INFO,
  TABBAR_INDEX,
  DESTINATION_SCENIC_SPOT_INFO,
  RESERVE_PEOPLE_INFO,
  HOTEL_INFO,
  USER_INFO,
  COMMODITY_DATES,
  ORDER_OPTION,
  IS_CALENDAR_SHOW,
  BOOKING_COMMODITY_ID,
  SET_IS_BOC_APP  // 添加导入
} from "./mutation-types.js";
import { setTimeout } from "timers";

// import {setStore, getStore} from '../config/mUtils'
//
// import {localapi, proapi} from 'src/config/env'

export default {
  // export const ERROR_TIPS ='ERROR_TIPS'

  // 保存授权前要访问的路径
  //   [E_BEFORE_LOGIN_URL_EXHIBITION_NEW](state, beforeLoginUrl){
  //     console.log("登录前的路径已经存储"+beforeLoginUrl);
  //     state.beforeLoginUrl = beforeLoginUrl;
  //   },
  [CURRENTPAGE](state, currentPage) {
    state.currentPage = currentPage;
  },
  [LANDINGPAGE](state, landingPage) {
    state.landingPage = landingPage;
  },
  [TABBAR_INDEX](state, tabbar_index) {
    state.tabbar_index = tabbar_index;
  },
  // 错误提示
  [SHOP_SUB_CATEGORIES_ID](state, shopSubCategoriesId) {
    state.shopSubCategoriesId = shopSubCategoriesId;
  },
  [MC_SHOPS](state, mcShops) {
    state.mcShops = mcShops;
  },
  [ERROR_TIPS](state, errorTips) {
    state.errorTips = errorTips;
  },
  // head头返回时所带参数
  [HEAD_GO_BACK_ITEM](state, headGoBackItem) {
    state.headGoBackItem = headGoBackItem;
  },
  [SHOP_CATEGORY_ID](state, shopCategoryId) {
    state.shopCategoryId = shopCategoryId;
  },
  [SHOP_PLACEHOLDER](state, shopPlaceholder) {
    state.shopPlaceholder = shopPlaceholder;
  },
  [QUERY_SHOPSUBCATEGORIES_TITLE](state, queryShopSubCategoriesTitle) {
    state.queryShopSubCategoriesTitle = queryShopSubCategoriesTitle;
  },
  [QUERY_DISTANCES_TITLE](state, queryDistancesTitle) {
    state.queryDistancesTitle = queryDistancesTitle;
  },
  [QUERY_REGIONS_TITLE](state, queryRegionsTitle) {
    state.queryRegionsTitle = queryRegionsTitle;
  },
  // 澳门商店详情
  [FM_SHOP_DETIALS](state, fmShopDetials) {
    state.fmShopDetials = fmShopDetials;
  },
  // 澳门商店状态头
  [FM_SHOP_HEADER](state, fmShopHeader) {
    state.fmShopHeader = fmShopHeader;
  },
  // 澳门商店ID
  [FM_SHOP_ID](state, fmShopID) {
    state.fmShopID = fmShopID;
  },
  [APP_ALERT_SHOW](state, message) {
    state.alertMessage = message;
    state.alertShow = true;
    setTimeout(() => {
      state.alertShow = false;
    }, 1500);
  },
  [ALERT_SHOW_CLOSE](state) {
    state.alertShow = false;
  },
  [LOCATION_INFO](state, data) {
    state.locationinfo = data;
  },
  [DESTINATION_SCENIC_SPOT_INFO](state, data) {
    state.destination_scenic_spot_info = data;
  },
  [HOTEL_INFO](state, data) {
    state.hotelInfo = data;
  },
  [USER_INFO](state, data) {
    state.userInfo = data;
  },
  [COMMODITY_DATES](state, data) {
    state.commodidy_dates = data;
  },
  [ORDER_OPTION](state, data) {
    state.order_option = data;
  },
  [IS_CALENDAR_SHOW](state, data) {
    state.is_calendar_show = data;
  },
  [BOOKING_COMMODITY_ID](state, data) {
    state.booking_commodity_id = data;
  },
  // 添加 isBocAPP 的 mutation
  [SET_IS_BOC_APP](state, isBocAPP) {
    debugger
    state.isBocAPP = isBocAPP;
    console.log('Vuex SET_IS_BOC_APP:', isBocAPP);
  }
};






// WEBPACK FOOTER //
// ./src/store/mutations.js